export default {
  generate(colors) {
    let css = '';
    if (colors?.primary) {
      css += `body { --primary-color: ${colors.primary}; }`;
      css += `.bc-primary { border-color: ${colors.primary} !important; }`;
      css += `.bc-primary-light { border-color: ${this.hexToRgbA(colors.primary, '0.2')} !important; }`;
      css += `.bg-primary {
        background-color: ${colors.primary} !important;
        color: white !important;
      }`;
      css += `.bg-primary > * { color: white !important; }`;
      css += `.bg-primary-light { background-color: ${this.hexToRgbA(colors.primary, '0.6')} !important; }`;
      css += `.bg-primary-extra-light { background-color: ${this.hexToRgbA(colors.primary, '0.06')} !important; }`;
      css += `.c-primary{ color: ${colors.primary} !important; }`;
      css += `.hover-bg-primary-lite:hover { background-color: ${this.hexToRgbA(colors.primary, '0.2')} !important; }`;
    }

    if (colors?.secondary) {
      css += `.bc-secondary { border-color: ${colors.secondary} !important; }`;
      css += `.bg-secondary { background-color: ${colors.secondary} !important; }`;
      css += `.bg-secondary-light { background-color: ${colors.secondary} !important; }`;
      css += `.bg-secondary-extra-light { background-color: ${this.hexToRgbA(colors.secondary, '0.06')} !important; }`;
      css += `.c-secondary{ color: ${colors.secondary} !important; }`;
      css += `.hover-bg-secondary-lite:hover { background-color: ${this.hexToRgbA(colors.secondary, '0.2')} !important; }`;
    }

    if (colors?.accent) {
      css += `.bc-accent { border-color: ${colors.accent} !important; }`;
      css += `.bg-accent { background-color: ${colors.accent} !important; }`;
      css += `.bg-accent-light { background-color: ${colors.accent} !important; }`;
      css += `.c-accent{ color: ${colors.accent} !important; }`;
      css += `.hover-bg-accent-lite:hover { background-color: ${this.hexToRgbA(colors.accent, '0.2')} !important; }`;
    }

    if (!css) return;

    const style = document.createElement('style');
    document.head.appendChild(style);
    style.appendChild(document.createTextNode(css));
  },

  hexToRgbA(hex, opacity) {
    if (!hex) return null;

    if (!hex.startsWith('#')) hex = `#${hex}`;

    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      let rgb;
      rgb = hex.substring(1).split('');
      if (rgb.length == 3) {
        rgb = [rgb[0], rgb[0], rgb[1], rgb[1], rgb[2], rgb[2]];
      }
      rgb = `0x${rgb.join('')}`;
      return `rgba(${[(rgb >> 16) & 255, (rgb >> 8) & 255, rgb & 255].join(',')},${opacity})`;
    }
    throw new Error('Bad Hex');
  },
};
